import React from "react";
import { Card, Box, Typography, Grid, Divider, Stack } from "@mui/material";

const chunkBreakPairs = (arr) => {
  const rows = [];
  for (let i = 0; i < arr.length; i += 2) rows.push(arr.slice(i, i + 2));
  return rows;
};
const breakShort = (t) => (t === "breakOut" ? "Out" : t === "breakIn" ? "In" : "·");

const DailyLogCard = ({
  title,
  inName,
  outName,
  inTime,
  outTime,
  /** Optional `{ type, time }[]` — when set, shows grouped breaks instead of two big lines */
  breaks,
  breakInTime,
  breakOutTime,
  totalLate,
  status,
}) => {
  return (
    <Card
      sx={{
        border: "1.5px solid #2E7D32",
        borderRadius: "16px",
        boxShadow: "none",
        p: 2,
        bgcolor: "#fff",
        height: "100%",
        display: "flex", // Center vertically
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center", // Center horizontally
      }}
    >
      <Box textAlign="center" width="100%">
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          {title}
        </Typography>

        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Grid item xs={6} textAlign="center">
            <Typography variant="body2" color="#388e3c" fontWeight={500}>
              {inName}
            </Typography>
            <Typography variant="h4" color="#757575" fontWeight={600}>
              {inTime}
            </Typography>
          </Grid>
          <Grid item xs={6} textAlign="center">
            <Typography variant="body2" color="#388e3c" fontWeight={500}>
              {outName}
            </Typography>
            <Typography variant="h4" color="#757575" fontWeight={600}>
              {outTime}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1, borderColor: "#2E7D32" }} />

        {Array.isArray(breaks) && breaks.length > 0 ? (
          <Stack spacing={1} width="100%" mb={1}>
            {chunkBreakPairs(breaks).map((pair, i) => (
              <Box
                key={i}
                sx={{
                  bgcolor: "#F1F8F4",
                  border: "1px solid #C8E6C9",
                  borderRadius: "10px",
                  px: 1.25,
                  py: 0.85,
                }}
              >
                <Typography variant="caption" fontWeight={700} color="#2E7D32">
                  Break {i + 1}
                </Typography>
                <Stack direction="row" justifyContent="space-around" flexWrap="wrap" gap={1} mt={0.35}>
                  {pair.map((b, j) => (
                    <Box key={j} textAlign="center" minWidth={56}>
                      <Typography variant="caption" color="#388e3c" fontWeight={600} display="block">
                        {breakShort(b.type)}
                      </Typography>
                      <Typography variant="body1" color="#757575" fontWeight={600}>
                        {b.time}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Box>
            ))}
          </Stack>
        ) : (
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Grid item xs={6} textAlign="center">
              <Typography variant="body2" color="#388e3c" fontWeight={500}>
                Break In
              </Typography>
              <Typography variant="h4" color="#757575" fontWeight={600}>
                {breakInTime ?? "—"}
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="center">
              <Typography variant="body2" color="#388e3c" fontWeight={500}>
                Break Out
              </Typography>
              <Typography variant="h4" color="#757575" fontWeight={600}>
                {breakOutTime ?? "—"}
              </Typography>
            </Grid>
          </Grid>
        )}

        {/* <Grid container mt={2}>
                    <Grid item xs={6} textAlign="center">
                        <Typography variant="caption" color="#757575">
                            Total Late
                        </Typography>
                        <Typography variant="body2" fontWeight={500} color="#757575">
                            {totalLate}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="center">
                        <Typography variant="caption" color="#757575">
                            Status
                        </Typography>
                        <Typography variant="body2" fontWeight={500} color="#388e3c">
                            {status}
                        </Typography>
                    </Grid>
                </Grid> */}
      </Box>
    </Card>
  );
};

export default DailyLogCard;
